/* ==========================================================================
   INTC Vape LP — base JS
   Ported from Komuso-Vape-LP-Handoff/shopify/page.komuso-vape-lp.liquid.

   Loaded from snippets/intc-vlp-head.liquid, which every intc-vlp-* section
   renders — so this script tag appears once per section. The guard below
   makes it run once.

   Owns only the shared .rise reveal animation. The buy-block behaviour
   (finish selector, sticky bar) lives in assets/intc-vlp-buy.js.

   The `intc-js` opt-in class on <html> is added by an inline script in the
   snippet so the hidden state never applies when JS is off or fails
   (SPEC.md section 4: do not move the hidden state out of the js class).
   ========================================================================== */
(function () {
  if (window.__intcVlpBase) return;
  window.__intcVlpBase = true;
  function initReveal() {
    var els = document.querySelectorAll('.intc-vlp .rise');
    if ('IntersectionObserver' in window) {
      var rev = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); rev.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { rev.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
